import React from 'react';
import { useTranslation } from 'react-i18next';

export default function FreePublishingAllowance({ capability }) {
  const { t, i18n } = useTranslation();
  const { usage } = capability;
  const reset = new Intl.DateTimeFormat(i18n.language, { dateStyle: 'medium', timeZone: 'UTC' }).format(new Date(usage.resetAt));
  return <details className="fpubl-allowance-compact" aria-label={t('freePublishing.allowanceTitle')}>
    <summary>{t('freePublishing.remaining', { count: usage.remaining, limit: usage.limit })}</summary>
    <div className="fpubl-usage"><span>{t('freePublishing.published', { count: usage.published })}</span>
      <span>{t('freePublishing.reserved', { count: usage.reserved })}</span>
      <span>{t('freePublishing.reset', { date: reset })}</span></div>
    <p>{t('freePublishing.sharedAllowance')}</p>
    {usage.remaining === 0 && <p role="status">{t('freePublishing.exhausted')}</p>}
  </details>;
}
